export enum LiveEventTrackerTab {
  Feed = 'feed',
  Games = 'games',
  Events = 'events',
  Statistics = 'statistics',
}
